export default __webpack_public_path__ + "images/UK.059f522.png";